import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installGlobalErrorHandlers } from './utils/clientErrorLogger';

installGlobalErrorHandlers();

// ════════════════════════════════════════════════════════════════════════
// 4 May 2026 — Electron native-dialog focus fix (DEFENSIVE)
// All in-app callers have been migrated to `dialog.confirm/prompt/alert`
// (DOM-based modals — see src/utils/dialog.ts) which don't trigger this
// bug. This shim is a safety net for any 3rd-party code or future code
// that still calls native dialogs: it re-focuses the renderer after each
// call so subsequent typing works without alt-tab / minimize.
// ════════════════════════════════════════════════════════════════════════
(() => {
  const restoreFocus = () => {
    setTimeout(() => {
      try {
        window.focus();
        const a = document.activeElement as HTMLElement | null;
        if (a && typeof a.focus === "function" && a !== document.body) {
          a.blur();
          a.focus();
        } else {
          (document.body as any)?.focus?.();
        }
      } catch { /* silent */ }
    }, 0);
  };
  const _confirm = window.confirm.bind(window);
  const _alert   = window.alert.bind(window);
  const _prompt  = window.prompt.bind(window);
  window.confirm = (msg?: string) => {
    if (process.env.NODE_ENV !== "production") console.warn("[dialog] window.confirm called — please migrate to `await dialog.confirm()`");
    const r = _confirm(msg); restoreFocus(); return r;
  };
  window.alert   = (msg?: any) => {
    if (process.env.NODE_ENV !== "production") console.warn("[dialog] window.alert called — please migrate to `await dialog.alert()`");
    const r = _alert(msg); restoreFocus(); return r;
  };
  window.prompt  = (msg?: string, def?: string) => {
    if (process.env.NODE_ENV !== "production") console.warn("[dialog] window.prompt called — please migrate to `await dialog.prompt()`");
    const r = _prompt(msg, def); restoreFocus(); return r;
  };
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
